import api from "./api";

export async function fetchQuizModes(params = {}) {
  const response = await api.get("/quiz/get-quiz-modes", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
